import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { Container } from "shards-react"

// Not Found Image
import NotFoundImage from "../images/not-found.jpeg"

import Switcher from "../components/switcher"

const NotFoundPage = () => (
  <Layout countryCode="JM">
    <Seo title="Page Not Found" countryCode="JM" />
    <img style={{ width: "100%" }} src={NotFoundImage} />
    <Container>
      <Switcher />
    </Container>
  </Layout>
)

export default NotFoundPage
